<template>
  <header>
    <webLogo></webLogo>
    <div class="left clearfix">
      <div class="mailbox" v-if="mechanUser.isOpenApi == 1">
        <span @click="openPage('/apiConfigure')">开发对接</span>
      </div>
      <div class="mailbox">
        <span @click="goSearchTool()">自主查询工具</span>
      </div>
      <div class="mailbox" v-if="checkAuth('planBook')">
        <span @click="openPage('/plan')">计划书</span>
      </div>
      <div class="mailbox">
        <el-badge :is-dot="noticeNums && noticeNums != 0 ? true : false" class="item">
          <span @click="openPage('/new_notice')">公告</span>
        </el-badge>
      </div>
      <div class="mailbox">
        <span @click="openPage('/help/index')">帮助中心</span>
      </div>
      <div class="headerimg clearfix">
        <div class="xl clearfix">
          <el-dropdown trigger="click" @command="out">
            <span class="el-dropdown-link">
              <img src="@static/images/yhtx.png" alt />
              <span class="userinfo-box">
                <div class="username-box">
                  <div class="name1" v-if="mechanUser.mechanFullName && mechanUser.isXbbMechan != 1 && mechanUser.isXbbSecondMechan != 1 && mechanUser.showCompany == 1">
                    {{ mechanUser.mechanFullName }}
                  </div>
                  <div class="name2">
                    {{ name }}
                    <span
                      class="user-status"
                      :class="{
                        wait: status == 1,
                        success: status == 2,
                        error: status == 3
                      }"
                      v-if="status != null"
                      >{{ all.AUDIT_STATUS[status] }}</span
                    >
                  </div>
                </div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <!-- <div class="bs">个人账号</div> -->
            </span>
            <el-dropdown-menu slot="dropdown" class="geren">
              <el-dropdown-item disabled class="index-dropdown-name">{{ name }}</el-dropdown-item>
              <el-dropdown-item disabled class="index-dropdown-status" v-if="all && level == 1">{{ all.MECHAN_USER_TYPE[type] }} </el-dropdown-item>
              <el-dropdown-item command="/#/authenticationInformation" v-if="level == 1">认证信息</el-dropdown-item>
              <el-dropdown-item command="/#/maininfo?id=10">账号设置</el-dropdown-item>
              <!-- <el-dropdown-item command="/#/empower" v-if="level!=3">授权设置</el-dropdown-item> -->
              <el-dropdown-item command="10">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import webLogo from '@/components/webLogo';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  props: [],
  components: {
    webLogo
  },
  data() {
    return {
      mechanUser: {},
      status: null,
      type: null,
      level: '',
      name: '',
      sum: 0
    };
  },
  watch: {},
  computed: {
    noticeNums() {
      return this.$store.state.notice.noticeNum;
    }
  },
  created() {
    this.$tools.getall(this.setAll);
    this.setUserInfo();
    this.getInfo();
    this.$store.dispatch('getNoticeNum');
  },
  methods: {
    // 跳转查询工具
    goSearchTool(){
      const userInfo = this.$tools.getLocal('userinfo');
      this.$http({
        type: "get",
        url: "/master/product/getSign",
        params: {
          mechanId: userInfo.mechanId
        }
      }).then((res) => {
        window.open(res.data);
      })
    },
    goIndex: function () {
      //跳转到首页
      this.$router.push('/index_content');
    },
    setAll(data) {
      this.all = data;
    },
    setUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      if (!data) {
        return;
      }
      this.name = data.name;
      this.level = data.level;
      this.mechanUser = data;
      this.type = data.mechanUserType; //1机构2个人
    },
    getInfo() {
      let url;
      if (this.type == 1) {
        //企业
        url = '/master/mechan/read/enterprise/detail';
      } else {
        //个人
        url = '/master/mechan/read/individual/detail';
      }
      this.$http({
        url: url,
        type: 'get'
      }).then(res => {
        this.status = res.data.auditStatus;
      });
    },
    openPage(url) {
      var rou = this.$router.resolve(url);
      window.open(rou.href, '_blank');
    },
    out: function (e) {
      if (e != 10) {
        if (location.href.includes(e)) {
          return;
        }
        this.$router.push(e.replace('/#', ''));
        this.$emit('handleSelect', e);
      } else {
        this.loginOut();
        localStorage.removeItem('userinfo');
        localStorage.removeItem('all');
        localStorage.removeItem('queryMechanInfo');
        // this.$tools.setLocal("userinfo", "");
        this.$router.push('/login');
      }
    },
    loginOut: function () {
      this.$http({
        url: '/master/user/logout',
        type: 'get',
        params: {}
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './webHeader.scss';
</style>